
<div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" *ngIf="!customerspec" id="exampleModalLongTitle">{{ 'customerwelcomeedit.header' | trans }}</h5>
        <h5 class="modal-title" *ngIf="customerspec" id="exampleModalLongTitle">{{ 'customerwelcomeedit.headerspecific' | trans }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span >&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p class="mb-1">{{ 'customerwelcomeedit.subheaderline1' | trans }}</p>
        <p class="text-muted">{{ 'customerwelcomeedit.subheaderline2' | trans }}</p>
        <p class="mb-0 text-muted">{{ 'customerwelcomeedit.customeruserwelcome' | trans }}</p>
        <div class="input-group mb-4 pb-3">
          <!-- <textarea class="form-control" [(ngModel)]="welcomeMessage.markup"></textarea> -->
          <quill-editor [modules]="modules" id="customerwelcome" class="w-100 toolontop" name="description" [(ngModel)]="welcomeMessage.markup"><p>{{ 'customerwelcomeedit.enterwelcome' | trans }}</p></quill-editor>
        </div>

        <p class="mb-0 pt-3">{{ 'customerwelcomeedit.customerusermedialink' | trans }}</p>
        <div class="input-group input-group-sm mb-3">
          <input type="text" placeholder="medialink" class="form-control rounded" [(ngModel)]="welcomeMessage.medialink">
        </div>

        <div class="alert alert-danger ml-0 mr-0" role="alert">
          <p class="mb-0">{{ 'customerwelcomeedit.alert' | trans }}
          </p>
        </div>
        
      </div>
      <div class="modal-footer">
        <button type="button" class="btn-close" data-dismiss="modal"><p class="btn-save-text">{{ 'customerwelcomeedit.close' | trans }}</p></button>
        <button type="button" class="btn-save" (click)="saveWelcomeMessage()"><p class="btn-save-text">{{ 'customerwelcomeedit.savechanges' | trans }}</p></button>
      </div>
    </div>
  </div>